<!-- 批量开票弹窗 -->
<template>
  <el-dialog title="批量开票" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" @close="handleClose">
    <div class="batch-invoice-dialog">
      <!-- 上传区域 -->
      <div
        class="upload-area"
        :class="{ 'is-dragover': isDragover }"
        @click="triggerFileInput"
        @drop.prevent="handleDrop"
        @dragover.prevent="isDragover = true"
        @dragleave.prevent="isDragover = false"
      >
        <input ref="fileInput" type="file" accept=".xls,.xlsx" style="display: none" @change="handleFileChange" />
        <div class="upload-icon">
          <i class="el-icon-upload"></i>
        </div>
        <div class="upload-text">拖拽文件至此或<span class="upload-link">点击上传</span></div>
        <div class="upload-hint">仅支持 .xls, .xlsx 格式文件</div>
      </div>
      <!-- 已选文件 -->
      <div v-if="file" class="selected-file">
        <div class="file-info">
          <i class="el-icon-document"></i>
          <span class="file-name">{{ file.name }}</span>
          <span class="file-size">({{ formatFileSize(file.size) }})</span>
        </div>
        <i class="el-icon-delete" @click="removeFile"></i>
      </div>
      <!-- 导入规则 -->
      <div class="import-rules">
        <div class="rules-header">
          <i class="el-icon-warning"></i>
          <span>导入规则提示：</span>
        </div>
        <ul class="rules-list">
          <li>1. 姓名+公司+发票金额+开票时间为唯一值，不可重复</li>
          <li>2. 模板数据错误则全部导入失败，请检查后重新上传</li>
        </ul>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="loading" :disabled="!file" @click="handleSubmit">确认导入</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importInboundInfo } from '@/api/invoiceManagement'

export default {
  name: 'BatchInvoiceDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: null,
      loading: false,
      isDragover: false
    }
  },
  methods: {
    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    // 文件选择变化
    handleFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.validateAndSetFile(file)
      }
    },
    // 拖拽放下
    handleDrop(e) {
      this.isDragover = false
      const file = e.dataTransfer.files[0]
      if (file) {
        this.validateAndSetFile(file)
      }
    },
    // 验证并设置文件
    validateAndSetFile(file) {
      const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      const validExtensions = ['.xls', '.xlsx']
      const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()

      if (!validTypes.includes(file.type) && !validExtensions.includes(extension)) {
        this.$message.error('仅支持 .xls, .xlsx 格式文件')
        return
      }
      this.file = file
      // 清空 input 以支持重复选择同一文件
      this.$refs.fileInput.value = ''
    },
    // 移除文件
    removeFile() {
      this.file = null
    },
    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    // 提交
    async handleSubmit() {
      if (!this.file) {
        this.$message.warning('请先选择文件')
        return
      }
      this.loading = true
      try {
        const formData = new FormData()
        formData.append('file', this.file)
        const res = await importInboundInfo(formData)
        if (res.statusCode === 200) {
          if (res.data != null){
            this.$message.error(res.message || '上传失败, 请查看错误文件')
            this.getErrorReport(res.data)
          }else{
            this.$message.success('已上传')
            this.$emit('success')
            this.handleClose()
          }
        }else{
          this.$message.error(res.message || '上传失败, 请稍后再试')
        }
      } catch (error) {
        console.error('批量开票导入失败', error)
        this.$message.error('上传失败, 请稍后再试')
      } finally {
        this.loading = false
      }
    },
    getErrorReport(downLoadId) {
      const url = `/autoapp-default-server-recovery/api/file/downLoadFailById`
      this.global.exportExcel(url, { downId: downLoadId }, '错误文件').catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    // 关闭弹窗
    handleClose() {
      this.file = null
      this.loading = false
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-invoice-dialog {
  padding: 0 20px;
}

.upload-area {
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #fafafa;

  &:hover,
  &.is-dragover {
    border-color: #67c23a;
    background-color: #f0f9eb;
  }

  .upload-icon {
    font-size: 48px;
    color: #67c23a;
    margin-bottom: 12px;
  }

  .upload-text {
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;

    .upload-link {
      color: #67c23a;
      text-decoration: underline;
    }
  }

  .upload-hint {
    font-size: 12px;
    color: #909399;
  }
}

.selected-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-top: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;

  .file-info {
    display: flex;
    align-items: center;

    i {
      font-size: 18px;
      color: #909399;
      margin-right: 8px;
    }

    .file-name {
      font-size: 14px;
      color: #303133;
      margin-right: 8px;
    }

    .file-size {
      font-size: 12px;
      color: #909399;
    }
  }

  .el-icon-delete {
    font-size: 16px;
    color: #909399;
    cursor: pointer;

    &:hover {
      color: #f56c6c;
    }
  }
}

.import-rules {
  margin-top: 20px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px solid #faecd8;

  .rules-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    i {
      font-size: 16px;
      color: #e6a23c;
      margin-right: 8px;
    }

    span {
      font-size: 14px;
      color: #606266;
      font-weight: 500;
    }
  }

  .rules-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 13px;
      color: #909399;
      line-height: 24px;
      padding-left: 24px;
    }
  }
}

.dialog-footer {
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/limitMonitoring/components/BatchInvoiceDialog.vue